import { combineReducers } from "redux";
import defaultReducer from "./defaultReducer";
import authReducer from "./authReducer";
import subscriptionsReducer from "./subscriptionsReducer";
import miscReducer from "./miscReducer";
import permissionsReducer from "./permissionsReducer";
import realtimeReducer from "./realtimeReducer";
import exportReducer from "./exportReducer";
import helpGuideReducer from "./helpGuideReducer";

const reducer = combineReducers({
  defaultReducer,
  authReducer,
  subscriptionsReducer,
  miscReducer,
  permissionsReducer,
  realtimeReducer,
  exportReducer,
  helpGuideReducer,
});

export default reducer;
